import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import UserDashboard from "@/pages/UserDashboard";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ADMIN_ROLES = ["admin", "org_admin", "venue_manager", "system_admin"];

/**
 * Single `/dashboard` URL that auto-routes to the right experience based on
 * the authenticated user's role. Falls back to a quick `/auth/me` round-trip
 * if the user wasn't passed via React Router state (e.g. direct URL hit).
 */
export default function DashboardRouter() {
  const ctx = useOutletContext();
  const ctxUser = ctx?.user;
  const [user, setUser] = useState(ctxUser || null);
  const [loading, setLoading] = useState(!ctxUser);

  useEffect(() => {
    if (ctxUser) {
      setUser(ctxUser);
      setLoading(false);
      return;
    }
    axios
      .get(`${API}/auth/me`)
      .then((res) => setUser(res.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, [ctxUser]);

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="dashboard-router-loading">
        <Loader2 className="w-8 h-8 animate-spin text-[hsl(var(--primary))]" />
      </div>
    );
  }

  return ADMIN_ROLES.includes(user?.role) ? <Dashboard /> : <UserDashboard />;
}
